<template>
  <a-drawer
    title="固定广告位"
    width="700"
    :closable="false"
    :visible="visible"
    @close="onClose"
    :footer-style="{ textAlign: 'right' }"
  >
    <!-- 表单 -->
    <a-form
      ref="RefForm"
      :model="formState"
      :label-col="{ span: 6 }"
      :wrapper-col="{ span: 16 }"
    >
      <!-- 动态表单项 -->
      <a-form-item
        v-for="(item, index) in detailList"
        :key="item.id"
        :label="item.name"
        :name="['detail', index, 'ad_id']"
      >
        <div style="display: flex; align-items: center; gap: 16px;">
          <a-input
            v-model:value="item.ad_id"
            placeholder="请输入"
            :disabled="isLoading"
            style="flex: 1;"
          />
          <a-switch
            v-model:checked="item.is_on_checked"
            checked-children="开"
            un-checked-children="关"
            :disabled="isLoading"
          />
        </div>
      </a-form-item>
    </a-form>
    <!-- 尾部 -->
    <template #footer>
      <div>
        <a-button style="margin-right: 8px" @click="onClose">取消</a-button>
        <a-button type="primary" @click="handleOk" :loading="isLoading">确定</a-button>
      </div>
    </template>
  </a-drawer>
</template>

<script setup>
import { reactive, ref, watch } from 'vue'
import { message } from 'ant-design-vue'
import { frontChargeEditFixedAd } from '@/api/operate'

// emit
const emit = defineEmits(['success'])
// 表单实例
const RefForm = ref(null)
// 显示
let visible = ref(false)
// 加载
let isLoading = ref(false)
// 记录ID
let recordId = ref(null)
// 详情列表
let detailList = ref([])
// 表单参数
const formState = reactive({
  detail: []
})

// 显示
function showModal (record) {
  recordId.value = record.id
  // 处理详情列表，为每个项添加 is_on_checked 字段
  detailList.value = (record.detail || []).map(item => ({
    ...item,
    is_on_checked: !!item.is_on,
    ad_id: item.ad_id || ''
  }))
  
  // 初始化表单数据
  formState.detail = detailList.value.map(item => ({
    id: item.id,
    ad_id: item.ad_id || '',
    is_on: item.is_on_checked ? 1 : 0
  }))
  
  // 显示
  visible.value = true
}

// 监听 detailList 变化，更新 formState
watch(detailList, (newVal) => {
  formState.detail = newVal.map(item => ({
    id: item.id,
    ad_id: item.ad_id || '',
    is_on: item.is_on_checked ? 1 : 0
  }))
}, { deep: true })

// 关闭
function onClose () {
  if (!isLoading.value) {
    visible.value = false
    resetFields()
  }
}

// 重置
function resetFields () {
  RefForm.value?.resetFields()
  detailList.value = []
  recordId.value = null
}

// 提交
function handleOk () {
  isLoading.value = true
  
  // 构建提交参数
  const params = {
    id: recordId.value,
    detail: detailList.value.map(item => ({
      id: item.id,
      ad_id: item.ad_id || '',
      is_on: item.is_on_checked ? 1 : 0
    }))
  }
  
  frontChargeEditFixedAd(params).then(res => {
    isLoading.value = false
    const { code, msg } = res
    if (code === 0) {
      message.success('操作成功')
      onClose()
      emit('success')
    } else {
      message.error(res.message || msg)
    }
  }).catch(err => {
    isLoading.value = false
    message.error('操作失败')
    console.error(err)
  })
}

// 抛出
defineExpose({
  showModal
})

</script>

<style scoped>
</style>

